import lunaStreamsQueue from './queue/store';
import lunaStreamsStreams from './streams/store';

export default {
  lunaStreamsStreams,
  lunaStreamsQueue,
};
